<script setup lang="ts">
defineProps<{
  value: string | None
}>()
</script>

<template>
  <span><span :class="$style.h" class="_noselect _pr02">#</span>{{ value || '...' }}</span>
</template>

<style module>
.h {
  color: var(--black-4);
}
</style>
